import { XIcon } from "@heroicons/react/outline";
import {} from "@heroicons/react/solid";
import { React } from "react";

const DomainModal = ({ title, url, show, onCloseCallback }) => {
  if (!show) {
    return null;
  }

  return (
    <div
      id="popup-modal"
      tabIndex="-1"
      className="fixed top-0 right-0 left-0 bottom-0 overflow-y-auto overflow-x-hidden flex justify-center items-center z-50 md:inset-0 h-modal md:h-full bg-[rgba(0,0,0,0.6)]"
    >
      <div className="relative p-4 w-full max-w-xl h-full md:h-auto">
        {/* <!-- Modal content --> */}
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          {/* <!-- Modal header --> */}
          <div className="flex flex-row place-items-center justify-end">
            <h1 className="px-4 py-3 text-lg font-normal text-gray-700">
              {title}
            </h1>
            <button
              onClick={() => onCloseCallback()}
              type="button"
              className="rounded-lg text-sm ml-auto px-4 py-3 inline-flex items-center"
              data-modal-toggle="popup-modal"
            >
              <XIcon className="w-5 h-5" />
            </button>
          </div>
          <div className="w-full h-0.5 bg-gray-200 mb-1"></div>
          {/* <!-- Modal body --> */}
          <div className="py-3 text-center h-72">
            <form className="mb-4 w-full flex flex-row flex-wrap justify-center">
              <input
                className="bg-[#E4E6FF] border-2 rounded-lg w-7/12 mr-6 py-1 px-4 text-gray-700 leading-none focus:bg-white border-transparent focus:border-transparent focus:ring-1"
                id="add"
                type="text"
                name="department"
                value={null}
                onChange={null}
                autoComplete="off"
                ref={null}
                placeholder="Domain Name"
              />
              <button className="bg-[#6767ce] hover:bg-[#4242A8] text-white py-1 rounded-lg w-1/6">
                ADD
              </button>
            </form>
            {/* table */}
            <div class="container flex justify-center mx-auto scroll-auto">
              <div class="flex flex-col">
                <div class="w-full">
                  <div class="border-b border-gray-200 shadow">
                    <table>
                      <thead class="flex bg-gray-200 w-full">
                        <tr className="whitespace-nowrap">
                          <th class="px-6 py-4 text-sm text-gray-500">
                            <div class="text-sm w-56">Name</div>
                          </th>
                          <th class="px-6 py-4 text-sm text-gray-500">
                            <div class="text-sm w-24">Delete</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        class="flex flex-col overflow-y-scroll"
                        style={{ height: 22 + "vh" }}
                      >
                        <tr class="whitespace-nowrap">
                          <td class="px-6 py-4">
                            <div class="group text-sm text-gray-500 w-56 truncate">
                              Smart Education
                              <span class="absolute z-50 hidden px-4 py-1 -mt-12 text-center bg-gray-500 rounded tooltip-text text-gray-100 group-hover:block">
                                Smart Education
                              </span>
                            </div>
                          </td>

                          <td class="px-6 py-4">
                            <button class="p-1 text-sm text-white bg-red-400 rounded w-24">
                              Delete
                            </button>
                          </td>
                        </tr>
                        <tr class="whitespace-nowrap">
                          <td class="px-6 py-4">
                            <div class="group text-sm text-gray-500 w-56 truncate">
                              Smart City
                              <span class="absolute z-50 hidden px-4 py-1 -mt-12 text-center bg-gray-500 rounded tooltip-text text-gray-100 group-hover:block">
                                Smart City
                              </span>
                            </div>
                          </td>
                          <td class="px-6 py-4">
                            <button class="p-1 text-sm text-white bg-red-400 rounded w-24">
                              Delete
                            </button>
                          </td>
                        </tr>
                        <tr class="whitespace-nowrap">
                          <td class="px-6 py-4">
                            <div class="group text-sm text-gray-500 w-56 truncate">
                              Healthcare
                              <span class="absolute z-50 hidden px-4 py-1 -mt-12 text-center bg-gray-500 rounded tooltip-text text-gray-100 group-hover:block">
                                Healthcare
                              </span>
                            </div>
                          </td>
                          <td class="px-6 py-4">
                            <button class="p-1 text-sm text-white bg-red-400 rounded w-24">
                              Delete
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DomainModal;
